/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Tab, Tabs } from '@mui/material';

const TabPanel = ({ children, value, index, ...other }) => (
  <Box
    aria-labelledby={`tabform-tab-${index}`}
    hidden={value !== index}
    id={`tabform-tabpanel-${index}`}
    role="tabpanel"
    {...other}
  >
    {value === index && <Box sx={{ p: { xs: 2, sm: 2.5 } }}>{children}</Box>}
  </Box>
);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const TabFormV2 = ({ tabPanels, currentTab, onChangeTab }) => {
  const [tab, setTab] = useState(currentTab);

  const handleChange = (event, newValue) => {
    onChangeTab(newValue);
    setTab(newValue);
  };

  useEffect(() => {
    if (Number.isInteger(currentTab) && currentTab !== tab) {
      setTab(currentTab);
    }
  }, [currentTab]);

  if (tabPanels.length === 1) {
    return <Box>{tabPanels[0].element}</Box>;
  }

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        overflow: 'hidden',
      }}
    >
      <Tabs
        value={tab}
        onChange={handleChange}
        variant="standard"
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          px: 2,
          minHeight: 48,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            minHeight: 48,
            minWidth: 'auto',
            mr: 2,
            px: 0,
            color: 'text.secondary',
            '&.Mui-selected': {
              color: 'primary.main',
            },
          },
          '& .MuiTabs-indicator': {
            backgroundColor: 'primary.main',
            height: 2,
          },
        }}
      >
        {tabPanels.map((panel, index) => (
          <Tab
            key={panel.label || index}
            label={panel.label}
            id={`tabform-tab-${index}`}
            aria-controls={`tabform-tabpanel-${index}`}
            disabled={panel.disabled}
          />
        ))}
      </Tabs>

      {tabPanels.map((panel, index) => (
        <TabPanel key={panel.label || index} value={tab} index={index}>
          {panel.element}
        </TabPanel>
      ))}
    </Box>
  );
};

const tabPanelShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  element: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
});

TabFormV2.propTypes = {
  tabPanels: PropTypes.arrayOf(tabPanelShape).isRequired,
  currentTab: PropTypes.number,
  onChangeTab: PropTypes.func,
};

TabFormV2.defaultProps = {
  currentTab: 0,
  onChangeTab: () => {},
};

export default TabFormV2;
